<ng-container [formGroup]="modbusIdCellFormGroup">
    <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50" *ngIf="item.$isInEditMode && item.configuration">
        <mat-label>Modbus Id</mat-label>
        <input matInput type="number" [formControl]="modbusIdFormControl" (input)="updateModbusId()" />
    </mat-form-field>

    <span *ngIf="!item.$isInEditMode">
        {{ item.modbusId }}
    </span>
</ng-container>
